import FloatLabel from "./FloatLabel";
import ErrorLabel from "./ErrorLabel";
import { RadioGroup, Radio, Box, HStack, Checkbox, CheckboxGroup} from "@chakra-ui/react";
import { useController } from "react-hook-form";
export default function OptionControl({ control, name, label, type, isDisabled = false, checked, setChecked, colorScheme = "brand", isRequired = false, rules, options = [] }) {
	const {
		field: { ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label} is required`, ...rules },
	});

	const renderSwitch = (type) => {
		switch (type) {
			case "radio":
				return (
					<>
						<RadioGroup
							pos="relative"
							border="1px solid"
							borderColor="inherit"
							borderRadius="md"
							outline="2px solid"
							outlineColor="transparent"
							outlineOffset="2px"
							h="10"
							minH="max-content"
							colorScheme={colorScheme}
							{...field}
						>
							<HStack h="full" pt="1px" pl="1rem" gap={5}>
								{options.map(({ value, label }) => (
									<>
										<Radio key={value} value={value} h="2.3rem" w="5rem">
											{label}
										</Radio>
									</>
								))}
							</HStack>
						</RadioGroup>
					</>
				);

			// case "radioWithCheck":
			// 	return (
			// 		<>
			// 			<RadioGroup
			// 				pos="relative"
			// 				border="1px solid"
			// 				borderColor="inherit"
			// 				borderRadius="md"
			// 				outline="2px solid"
			// 				outlineColor="transparent"
			// 				outlineOffset="2px"
			// 				minH="max-content"
			// 				colorScheme={colorScheme}
			// 				{...field}
			// 			>
			// 				<Stack h="full" pt="1px" pl="1rem">
			// 					<Box pt={2}>
			// 						<Checkbox
			// 							colorScheme={colorScheme}
			// 							defaultChecked={checked}
			// 							// defaultChecked={field && !!field.value === (undefined && 0) ? false : true}
			// 							onChange={(e) => {
			// 								setChecked(e.target.checked);
			// 							}}
			// 						>
			// 							Yes
			// 						</Checkbox>
			// 					</Box>
			// 					{checked && (
			// 						<>
			// 							<Text>
			// 								Paid By{" "}
			// 								<Text as="b" color="red.400">
			// 									*
			// 								</Text>
			// 							</Text>
			// 							<HStack spacing={10}>
			// 								{options.map(({ value, label }) => (
			// 									<>
			// 										<Radio key={value} value={value} h="2.3rem" w="5rem">
			// 											{label}
			// 										</Radio>
			// 									</>
			// 								))}
			// 							</HStack>
			// 						</>
			// 					)}
			// 				</Stack>
			// 			</RadioGroup>
			// 		</>
			// 	);
			case "checkbox":
				return (
					<CheckboxGroup pos="relative" outline="2px solid" outlineColor="transparent" outlineOffset="2px" minH="max-content" colorScheme={colorScheme} {...field}>
						<HStack border="1px solid" borderRadius="md" borderColor="inherit" wrap="wrap" h="full" p={3} gap={5}>
							{options.map(({ value, label }) => (
								<>
									<Checkbox key={value} value={value} h="full" w="5rem">
										{label}
									</Checkbox>
								</>
							))}
						</HStack>
					</CheckboxGroup>
				);
			default:
				return "";
		}
	};
	return (
		<Box as="fieldset" disabled={isDisabled} w="full">
			<FloatLabel label={label} isRequired={isRequired}>
				<fieldset disabled={isDisabled}>{renderSwitch(type)}</fieldset>
				<ErrorLabel>{error?.message}</ErrorLabel>
			</FloatLabel>
		</Box>
	);
}
// import FloatLabel from "./FloatLabel";
// import ErrorLabel from "./ErrorLabel";
// import { RadioGroup, Radio, Box, HStack, Checkbox, CheckboxGroup, VStack } from "@chakra-ui/react";
// import { useController } from "react-hook-form";
// import { useState } from "react";

// export default function OptionControl({ control, name, label, type, isDisabled = false, colorScheme = "brand", isRequired = false, rules, options = [] }) {
// 	const {
// 		field: { ...field },
// 		fieldState: { error },
// 	} = useController({
// 		name,
// 		control,
// 		rules: { required: isRequired && `${label} is required`, ...rules },
// 	});
// 	const renderSwitch = (type) => {
// 		switch (type) {
// 			case "radio":
// 				return (
// 					<>
// 						<RadioGroup
// 							pos="relative"
// 							border="1px solid"
// 							borderColor="inherit"
// 							borderRadius="md"
// 							outline="2px solid"
// 							outlineColor="transparent"
// 							outlineOffset="2px"
// 							h="10"
// 							minH="max-content"
// 							colorScheme={colorScheme}
// 							{...field}
// 						>
// 							<HStack h="full" pt="1px" pl="1rem">
// 								{options.map(({ value, label }) => (
// 									<>
// 										<Radio value={value} h="2.3rem" w="5rem">
// 											{label}
// 										</Radio>
// 									</>
// 								))}
// 							</HStack>
// 						</RadioGroup>
// 					</>
// 				);
// 			case "checkbox":
// 				return (
// 					<CheckboxGroup pos="relative" outline="2px solid" outlineColor="transparent" outlineOffset="2px" minH="max-content" colorScheme={colorScheme} {...field}>
// 						<HStack border="1px solid" borderRadius="md" borderColor="inherit" wrap="wrap" h="full" pt="1px" px="1rem">
// 							{options.map(({ value, label }) => (
// 								<>
// 									<Checkbox value={value} h="full" w="5rem">
// 										{label}
// 									</Checkbox>
// 								</>
// 							))}
// 						</HStack>
// 					</CheckboxGroup>
// 				);
// 			default:
// 				return "";
// 		}
// 	};
// 	return (
// 		<Box as="fieldset" disabled={isDisabled} w="full">
// 			<FloatLabel label={label} isRequired={isRequired}>
// 				<fieldset disabled={isDisabled}>{renderSwitch(type)}</fieldset>
// 				<ErrorLabel>{error?.message}</ErrorLabel>
// 			</FloatLabel>
// 		</Box>
// 	);
// }
